module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "id": "empresa"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('empresa')
      }
    }
  }, [_vm._v("DADOS DA EMPRESA")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "perfil"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('perfil')
      }
    }
  }, [_vm._v("PERFIL DE USUÁRIO")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "pedidos"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('pedidos')
      }
    }
  }, [_vm._v("PEDIDOS")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "funcionamento"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mudarAtivo('funcionamento')
      }
    }
  }, [_vm._v("FUNCIONAMENTO")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'empresa'),
      expression: "ativo === 'empresa'"
    }]
  }, [_c('Circle8', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner"
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n                      CEP:\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cep),
      expression: "cep"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cep = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.buscaCEP
    }
  }, [_vm._v("Buscar Endereco")])]), _vm._v(" "), _c('li', [_vm._v("\n                    RUA:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rua),
      expression: "rua"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rua)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rua = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._v("\n                    NUMERO:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numero),
      expression: "numero"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numero = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li'), _c('li', [_vm._v("\n                    BAIRRO:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bairro),
      expression: "bairro"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bairro = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._v("\n                    CIDADE:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade),
      expression: "cidade"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cidade = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._v("\n                    ESTADO:\n                    "), _c('div', {
    staticClass: "form-group inputEndereco"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estado),
      expression: "estado"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "sel1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("AC")]), _vm._v(" "), _c('option', [_vm._v("AL")]), _vm._v(" "), _c('option', [_vm._v("AP")]), _vm._v(" "), _c('option', [_vm._v("AM")]), _vm._v(" "), _c('option', [_vm._v("BA")]), _vm._v(" "), _c('option', [_vm._v("CE")]), _vm._v(" "), _c('option', [_vm._v("DF")]), _vm._v(" "), _c('option', [_vm._v("ES")]), _vm._v(" "), _c('option', [_vm._v("GO")]), _vm._v(" "), _c('option', [_vm._v("MA")]), _vm._v(" "), _c('option', [_vm._v("MT")]), _vm._v(" "), _c('option', [_vm._v("MS")]), _vm._v(" "), _c('option', [_vm._v("MG")]), _vm._v(" "), _c('option', [_vm._v("PA")]), _vm._v(" "), _c('option', [_vm._v("PB")]), _vm._v(" "), _c('option', [_vm._v("PR")]), _vm._v(" "), _c('option', [_vm._v("PE")]), _vm._v(" "), _c('option', [_vm._v("PI")]), _vm._v(" "), _c('option', [_vm._v("RJ")]), _vm._v(" "), _c('option', [_vm._v("RN")]), _vm._v(" "), _c('option', [_vm._v("RS")]), _vm._v(" "), _c('option', [_vm._v("RO")]), _vm._v(" "), _c('option', [_vm._v("RR")]), _vm._v(" "), _c('option', [_vm._v("SC")]), _vm._v(" "), _c('option', [_vm._v("SP")]), _vm._v(" "), _c('option', [_vm._v("SE")]), _vm._v(" "), _c('option', [_vm._v("TO")])])])]), _vm._v(" "), _c('li', [_vm._v("\n                    COMPLEMENTO:\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.complemento),
      expression: "complemento"
    }],
    staticClass: "form-control inputEndereco",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.complemento = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'perfil'),
      expression: "ativo === 'perfil'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permite_impressao),
      expression: "permite_impressao"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.permite_impressao) ? _vm._i(_vm.permite_impressao, null) > -1 : _vm._q(_vm.permite_impressao, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.permite_impressao,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.permite_impressao = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.permite_impressao = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permite_impressao = $$c
        }
      }
    }
  }), _vm._v("\n                        1. Permite Impressão de Pedido automaticamente\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permite_email),
      expression: "permite_email"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.permite_email) ? _vm._i(_vm.permite_email, null) > -1 : _vm._q(_vm.permite_email, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.permite_email,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.permite_email = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.permite_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.permite_email = $$c
        }
      }
    }
  }), _vm._v("\n                        2. Permite o envio de e-mail de notificação ao cliente enviar dúvida\n                      ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'pedidos'),
      expression: "ativo === 'pedidos'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.notifica_cliente),
      expression: "config.notifica_cliente"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.notifica_cliente) ? _vm._i(_vm.config.notifica_cliente, null) > -1 : _vm._q(_vm.config.notifica_cliente, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.notifica_cliente,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config, "notifica_cliente", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config, "notifica_cliente", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config, "notifica_cliente", $$c)
        }
      }
    }
  }), _vm._v("\n                        1. Notifica o cliente sobre alteração de status\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', [_c('h6', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.tabelaVariaveis
    }
  }, [_vm._v("Tabela de Variáveis")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.1 Texto padrão para notificação de status APROVADO")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_aprovado),
      expression: "config.texto_padrao_aprovado"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_aprovado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_aprovado", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_aprovado) + " ")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.2 Texto padrão para notificação de status REPROVADO")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_reprovado),
      expression: "config.texto_padrao_reprovado"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_reprovado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_reprovado", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_reprovado))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.3 Texto padrão para notificação de status CANCELADO")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_cancelado),
      expression: "config.texto_padrao_cancelado"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_cancelado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_cancelado", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_cancelado))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("1.4 Texto padrão para notificação de status SAIU PARA ENTREGA")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.texto_padrao_entrega),
      expression: "config.texto_padrao_entrega"
    }],
    staticClass: "form-control textarea",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.config.texto_padrao_entrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "texto_padrao_entrega", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.config.texto_padrao_entrega))])])])])]), _c('br'), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("2. Raio de Entrega dos pedidos (Km)")]), _vm._v(" "), (_vm.frete.length > 0) ? _c('div', _vm._l((_vm.frete), function(item, index) {
    return _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('h5', [_vm._v("Até")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.distancia),
        expression: "item.distancia"
      }],
      staticClass: "form-control inputFrete",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.distancia)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "distancia", $event.target.value)
        }
      }
    }), _c('h5', [_vm._v("km, cobrar R$")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.valor),
        expression: "item.valor"
      }],
      staticClass: "form-control inputFrete",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.valor)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "valor", $event.target.value)
        }
      }
    }), _vm._v(" "), (index === 0) ? _c('a', {
      on: {
        "click": _vm.adicionarFrete
      }
    }, [_c('h5', {
      staticClass: "inputRaioEntrega"
    }, [_vm._v("Novo Raio de Entrega")])]) : _c('a', {
      staticClass: "removeFrete",
      on: {
        "click": function($event) {
          return _vm.removerFrete(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0) : _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('h5', [_vm._v("Até")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.raio_entrega),
      expression: "config.raio_entrega"
    }],
    staticClass: "form-control inputFrete",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.raio_entrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "raio_entrega", $event.target.value)
      }
    }
  }), _c('h5', [_vm._v("km, cobrar R$")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.taxa_entrega),
      expression: "config.taxa_entrega"
    }],
    staticClass: "form-control inputFrete",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.taxa_entrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "taxa_entrega", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.imprimir_descricao),
      expression: "config.imprimir_descricao"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.imprimir_descricao) ? _vm._i(_vm.config.imprimir_descricao, null) > -1 : _vm._q(_vm.config.imprimir_descricao, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.imprimir_descricao,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config, "imprimir_descricao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config, "imprimir_descricao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config, "imprimir_descricao", $$c)
        }
      }
    }
  }), _vm._v("\n                          3. Imprimir descrição do produto no Recibo.\n                        ")])])]), _c('br'), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                          4. Valor mínimo para pedidos\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.pedido_minimo),
      expression: "config.pedido_minimo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.pedido_minimo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "pedido_minimo", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'funcionamento'),
      expression: "ativo === 'funcionamento'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, _vm._l((_vm.funcionamento), function(linha) {
    return _c('li', [_c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.aberto),
        expression: "linha.aberto"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(linha.aberto) ? _vm._i(linha.aberto, null) > -1 : (linha.aberto)
      },
      on: {
        "change": function($event) {
          var $$a = linha.aberto,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(linha, "aberto", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(linha, "aberto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(linha, "aberto", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(linha.dia.toUpperCase()) + "\n                          ")])]), _vm._v(" "), _c('ul', {
      attrs: {
        "type": "none"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (linha.aberto),
        expression: "linha.aberto"
      }]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_1),
        expression: "linha.hr_abertura_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_1", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_1),
        expression: "linha.hr_fechamento_1"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_1", $event.target.value)
        }
      }
    }), _vm._v("    -   "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_abertura_2),
        expression: "linha.hr_abertura_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_abertura_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_abertura_2", $event.target.value)
        }
      }
    }), _vm._v(" às "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (linha.hr_fechamento_2),
        expression: "linha.hr_fechamento_2"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (linha.hr_fechamento_2)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(linha, "hr_fechamento_2", $event.target.value)
        }
      }
    })])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativo === 'promocao'),
      expression: "ativo === 'promocao'"
    }]
  }, [_c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                        1. Promoção Por Período\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_vm._v("\n                        1.1. Promoção ativa entre \n                        ")]), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 noPadding"
  }, [_vm._v("\n                          1.2. Promoção válida para pedidos acima de \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1",
    staticStyle: {
      "margin-left": "-3%"
    }
  }), _vm._v("\n                        reais\n                      ")]), _c('br'), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio1),
      expression: "optradio1"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio1",
      "value": "item"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio1, "item")
    },
    on: {
      "change": function($event) {
        _vm.optradio1 = "item"
      }
    }
  }), _vm._v("Item Brinde")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio1),
      expression: "optradio1"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio1",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio1, "desc")
    },
    on: {
      "change": function($event) {
        _vm.optradio1 = "desc"
      }
    }
  }), _vm._v("Desconto")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optradio1 === 'desc'),
      expression: "optradio1 === 'desc'"
    }]
  }, [_vm._v("\n                          1.3. Porcentagem de desconto\n                          ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                        2. Promoção Por Pedidos Realizados\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1 noPadding"
  }, [_vm._v("\n                          2.1. A partir de\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" pedidos\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio2),
      expression: "optradio2"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio2",
      "value": "item"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio2, "item")
    },
    on: {
      "change": function($event) {
        _vm.optradio2 = "item"
      }
    }
  }), _vm._v("Item Brinde")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio2),
      expression: "optradio2"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio2",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio2, "desc")
    },
    on: {
      "change": function($event) {
        _vm.optradio2 = "desc"
      }
    }
  }), _vm._v("Desconto")])])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optradio2 === 'desc'),
      expression: "optradio2 === 'desc'"
    }]
  }, [_vm._v("\n                          2.2. Porcentagem de desconto\n                          ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("\n                        3. Promoção de Aniversário\n                      ")])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio3),
      expression: "optradio3"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio3",
      "value": "item"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio3, "item")
    },
    on: {
      "change": function($event) {
        _vm.optradio3 = "item"
      }
    }
  }), _vm._v("Item Brinde")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optradio3),
      expression: "optradio3"
    }],
    attrs: {
      "type": "radio",
      "name": "optradio3",
      "value": "desc"
    },
    domProps: {
      "checked": _vm._q(_vm.optradio3, "desc")
    },
    on: {
      "change": function($event) {
        _vm.optradio3 = "desc"
      }
    }
  }), _vm._v("Desconto")])])]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "none"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.optradio3 === 'desc'),
      expression: "optradio3 === 'desc'"
    }]
  }, [_vm._v("\n                          3.1. Porcentagem de desconto\n                          ")])])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravarConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.gravarConfig
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f08f7bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Setting.vue
// module id = 1248
// module chunks = 1